import { render, staticRenderFns } from "./productDetailModal.vue?vue&type=template&id=3013cebb&"
import script from "./productDetailModal.vue?vue&type=script&lang=js&"
export * from "./productDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports